export default function (error, vueCompoment, prefix) {
  if (error.response != null) {
    vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' ' + error.response.status + ', ' + error.response.data)
  } else {
    console.log(error)
    vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' Не доступен')
  }
}



// WEBPACK FOOTER //
// ./src/technical/serverErrorHandling.js